import { UploadedFile } from '@paragon/component-processor';

export async function prepareFileDataForUpload(fileData: readonly UploadedFile[]) {
  await Promise.all(fileData.map((file) => file.getContents()));

  return fileData.map((file) => ({
    name: file.filename,
    fileType: file.filetype!,
    base64Contents: file.contents!,
  }));
}
